import { render, staticRenderFns } from "./WorkflowTaskMultipleBtn.vue?vue&type=template&id=72ed8558&scoped=true&"
import script from "./WorkflowTaskMultipleBtn.vue?vue&type=script&lang=js&"
export * from "./WorkflowTaskMultipleBtn.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowTaskMultipleBtn.vue?vue&type=style&index=0&id=72ed8558&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed8558",
  null
  
)

export default component.exports